import React, { useEffect, useState } from "react";
import { ScrollText, ChevronRight } from "lucide-react";
import api, { TRY, trDate } from "@/lib/api";
import { Card } from "@/components/Cards";

export default function ChequeDueBanner({ goTo }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/cashbook/cheque-reminders").then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <Card className="p-4 border-teal-500/40 bg-teal-500/5" data-testid="cheque-due-banner">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-lg bg-teal-500/15 text-teal-400 flex items-center justify-center shrink-0"><ScrollText className="h-5 w-5" /></div>
          <div>
            <div className="font-heading font-semibold text-teal-300">Vadesi yaklaşan çekler</div>
            <div className="text-sm text-muted-foreground mt-0.5 flex flex-wrap gap-1.5">
              {items.map((c) => (
                <span key={c.id} data-testid={`cheque-due-${c.id}`} className="rounded-md bg-card/70 border border-border px-2 py-0.5 text-xs">
                  <span className={`font-semibold ${c.direction === "out" ? "text-rose-300" : "text-emerald-300"}`}>{c.direction === "out" ? "Ödeme" : "Tahsil"}</span>{" "}
                  <span className="font-medium text-foreground">{c.bank || c.party || "Çek"}</span>
                  {c.cheque_no && <span className="text-muted-foreground"> #{c.cheque_no}</span>} · vade {trDate(c.due_date)}{" "}
                  <span className={`font-mono ${c.days_left < 0 ? "text-rose-400" : c.days_left <= 2 ? "text-amber-400" : "text-teal-300"}`}>
                    ({c.days_left < 0 ? `${-c.days_left} gün geçti` : c.days_left === 0 ? "bugün" : `${c.days_left} gün`})
                  </span> · <span className="font-mono">{TRY(c.amount)}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
        <button onClick={() => goTo && goTo("cashbook")} data-testid="cheque-due-goto" className="text-sm font-semibold text-primary inline-flex items-center gap-1 hover:underline shrink-0">Çek Portföyü'ne git <ChevronRight className="h-4 w-4" /></button>
      </div>
    </Card>
  );
}
